import React from "react";
import { Link } from "react-router-dom";

const SERVICE_AREA_SLUGS = [
  "austin", "round-rock", "cedar-park", "georgetown", "leander",
  "liberty-hill", "pflugerville", "hutto", "lakeway", "bee-cave",
  "kyle", "buda", "san-marcos", "dripping-springs", "wimberley",
  "bastrop", "elgin", "lockhart", "manor", "taylor",
];

const slugToLabel = (slug) =>
  slug.split("-").map((w) => w[0].toUpperCase() + w.slice(1)).join(" ");

export default function HomeServiceAreas() {
  return (
    <section className="section-pad bg-br-black text-white">
      <div className="container-br">
        <div className="max-w-2xl mb-8">
          <div className="br-eyebrow text-br-bronze-2">Service Areas</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Serving Austin & Central Texas</h2>
          <p className="mt-3 text-gray-300">From central Austin neighborhoods to growing communities across the Hill Country, we work with homeowners throughout Central Texas.</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
          {SERVICE_AREA_SLUGS.map((c) => (
            <Link key={c} to={`/service-areas/${c}`} className="text-xs tracking-widest uppercase border border-br-line px-3 py-2.5 hover:border-br-bronze hover:text-br-bronze-2">
              {slugToLabel(c)}, TX
            </Link>
          ))}
        </div>
        <div className="mt-6"><Link to="/service-areas" className="text-sm uppercase tracking-widest font-bold text-br-bronze-2 hover:underline">View all service areas →</Link></div>
      </div>
    </section>
  );
}
